import {useState} from 'react'
 
import FarmerCropCutForm from './FarmerCropCutForm';
import FarmerCropCutList from './FarmerCropCutList';

const FarmerCropCut = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");
return (
  <>
    {fromIsShown ? (
        <FarmerCropCutForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
      ) : (
        <FarmerCropCutList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
      )}

  </>
  )
}

export default FarmerCropCut